module.exports = "<div class=\"loader\">\n\t<img *ngIf=\"show\" src=\"{{baseUrl}}assets/giphy.gif\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/src/app/loader/loader.component.html
// module id = ../../../../../src/app/loader/loader.component.html
// module chunks = 1